import { render } from "./manageWebBotFlowSettings.vue?vue&type=template&id=89eb196e&scoped=true"
import script from "./manageWebBotFlowSettings.vue?vue&type=script&lang=js"
export * from "./manageWebBotFlowSettings.vue?vue&type=script&lang=js"

import "./manageWebBotFlowSettings.vue?vue&type=style&index=0&id=89eb196e&scoped=true&lang=css"
import "./manageWebBotFlowSettings.vue?vue&type=style&index=1&id=89eb196e&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89eb196e"]])

export default __exports__